import React from 'react';
import moment from 'moment';
import Pagination from '../common/Pagination';

const MagazineTable = ({
  list,
  currentPage,
  itemsPerPage,
  onPageChange,
  handleItemClick,
  handleDeleteMagazine
}) => {
  const getCurrentItems = (items) => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return items?.slice(indexOfFirstItem, indexOfLastItem);
  };

  const onDeleteMagazine = async (id) => {
    if (window.confirm("Are you sure you want to delete this magazine?")) {
      await handleDeleteMagazine(id);
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title fw-bold">Magazine List</h5>
          <button
            className="btn btn-primary"
            onClick={() => handleItemClick(null, "magazine-create")}
          >
            Add New Magazine
          </button>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-light">
              <tr>
                <th scope="col">PDF Name</th>
                <th scope="col">PDF URL</th>
                <th scope="col">View Count</th>
                <th scope="col">Created Date</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {getCurrentItems(list)?.map((item) => (
                <tr key={item._id}>
                  <td>{item.pdfName}</td>
                  <td>
                    <a
                      href={`${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${item.pdfUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-dark"
                      style={{
                        ":hover": {
                          color: "blue",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {item.pdfUrl}
                    </a>
                  </td>
                  <td>{item.viewCount}</td>
                  <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-info me-2"
                      onClick={() => handleItemClick(item, "magazine")}
                    >
                      View
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => onDeleteMagazine(item._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={currentPage}
          totalItems={list?.length || 0}
          itemsPerPage={itemsPerPage}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default MagazineTable; 